import React from 'react';

import {LoadingSpinner} from '@newsela/angelou';
import Loadable from 'react-loadable';
import {Route, Redirect} from 'react-router-dom';

import {
  teacherOnboardingRoot,
  onboardingPath,
} from 'static/three-oh/src/modules/constants/routePaths';

const LazyTeacherOnboarding = Loadable({
  loader: () => import(
    /* webpackChunkName: "TeacherOnboarding" */
    './components/TeacherOnboarding'
  ),
  loading: LoadingSpinner,
});

const TeacherOnboardingRedirect = () => {
  const step = sessionStorage.getItem('resume-onboarding') ?? 0;
  sessionStorage.removeItem('resume-onboarding');
  return <Redirect to={`${onboardingPath}/${step}`} />;
};

const TeacherOnboardingRoute = [
  <Route
    key="TeacherOnboardingIndexRedirect"
    path={teacherOnboardingRoot}
    exact
    render={TeacherOnboardingRedirect}
  />,
  <Route
    key="TeacherOnboardingCatchAll"
    path={onboardingPath + '/:step(\\d+)'}
    component={LazyTeacherOnboarding}
  />,
];

export default TeacherOnboardingRoute;
